import axios from 'axios'
import { Message } from 'element-ui'
import store from './store';
import router from './router'
import util from '@/assets/js/util.js'

let logOutStatus = 0;
let loginUrl = false;
/** 泳道参数设置 */
const swimlane = util.getCookie('swimlane') || '';
// 请求拦截器
axios.interceptors.request.use(config => {
	config.transformRequest = null
	loginUrl = config.url == '/v1/passport/login/pc/user_login';
	if (process.env.NODE_ENV !== 'production') {
        swimlane && (config.headers['swimlane'] = swimlane);
    }
	if (config.method === 'get') {
		// GET
		config.params = config.params || config.data
	} else {
		// POST/DELETE...
		if (Object.prototype.toString.call(config.data) === '[object FormData]') {
			// FORMDATA
		} else if (typeof config.data == 'object') {
			// JSON
			config.transformRequest = obj => {
				let ret = ''
				for (let key in obj) {
					ret += `${ encodeURIComponent(key) }=${ encodeURIComponent(obj[key]) }&`
				}
				return ret
			}
		}
	}
	return config;
})

// 响应拦截器
axios.interceptors.response.use(response => {
	const data = response['data']
	const headers = response['headers']
	if (!!headers.passtoken) {
		util.setCookie('passToken', headers.passtoken, 20)
	}
	if (response['request'] && data.code) {
		const code = data.code;
		if (loginUrl) {
			logOutStatus = 0;
		}
		if (code == 200) {
			return data
        } else if (code == 401) {
			// 只弹一次未登录信息
			if (!logOutStatus) {
				Message.error('登录信息过期，请重新登录')
				logOutStatus++;
			}
			const uidold = store.state.user.uid
			store.dispatch('logOut').then(() => {
				router.push({ path: '/login' })
			})
			const backoff = new Promise(resolve => {
				const checkLoop = setInterval(() => {
					// 反复查询，直到登录成功
					const uidnew = store.state.user.uid
					if (uidnew) {
						if (uidnew == uidold) {
							// 如果是同一账号才会自动发起刚才的请求
							resolve()
						}
						clearInterval(checkLoop)
					}
				}, 1000)
			})
			return new Promise(resolve => {
				backoff.then(() => {
					axios(response.config).then(res => {
						resolve(res)
					})
				})
			})
		} else {
			if (response.config.handleError) {
				return Promise.reject(data)
			} else {
				Message.error(data.message)
				if (response.config['custom']) {
					// 返回自定义处理response
					return data
				} else {
					// 不再返回
					return new Promise(() => {})
				}
			}
		}
	} else {
		return response
	}
}, error => {
	if (error.config.handleError) {
		return Promise.reject(error)
	} else {
		Message.error('未知错误')
		return new Promise(() => {})
	}
})
